export default {
  getTrainSearchList: '/v3/mapping/bd/train/client/core/trainSearch'
}
